@if (showChoice()) {
  <ng-container>
    <ion-item lines="full">
      <ion-title class="ion-no-padding ion-padding-vertical"
        ><b>{{ title() | translate }}</b></ion-title
      >
      <ion-buttons slot="end">
        <ion-button (click)="dismiss()">
          <ion-icon name="close-outline"></ion-icon>
        </ion-button>
      </ion-buttons>
    </ion-item>
    <div class="ion-margin-bottom">
      <ion-grid class="ion-margin-top">
        <ion-row>
          <ion-col class="ion-text-center">
            <ion-icon
              [icon]="helpCircleOutline"
              color="medium"
              class="icon-x3"
            ></ion-icon>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col class="ion-text-center">
            <ion-label
              class="ion-no-padding ion-padding-horizontal panel-label-text"
            >
              {{ message() | translate }}
            </ion-label>
          </ion-col>
        </ion-row>
      </ion-grid>
    </div>
    <ion-footer>
      <div class="ion-text-center ion-padding">
        <ion-button
          id="showmoddel"
          color="primary"
          (click)="onYesClicked()"
          align-self-center
        >
          <small>{{ 'general_yes' | translate }}</small></ion-button
        >
        <ion-button
          id="showmoddel"
          color="primary"
          (click)="dismiss()"
          align-self-center
        >
          <small>{{ 'general_no' | translate }}</small></ion-button
        >
      </div>
    </ion-footer>
  </ng-container>
} @else {
  <ion-item lines="full">
    <ion-title class="ion-no-padding ion-padding-vertical"
      ><b>{{ title() | translate }}</b></ion-title
    >
    <ion-buttons slot="end">
      <ion-button (click)="dismiss()">
        <ion-icon name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-item>
  <div class="ion-margin-bottom">
    <ion-grid class="ion-margin-top">
      <ion-row>
        <ion-col class="ion-text-center ion-margin ion-padding-horizontal">
          @if (activationProgress() > 0) {
            <ion-progress-bar
              color="primary"
              [value]="progressValue()"
            ></ion-progress-bar>
          } @else {
            <ion-progress-bar
              color="primary"
              type="indeterminate"
            ></ion-progress-bar>
          }
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col class="ion-text-center ion-margin ion-padding-horizontal">
          <ion-label
            class="ion-no-padding ion-padding-horizontal panel-label-text"
          >
            {{ activationMessage() }}
          </ion-label>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
  <ion-footer>
    <div class="ion-text-center ion-padding">
      <ion-button
        [disabled]="!activationDone()"
        id="showmoddel"
        color="primary"
        (click)="dismiss()"
        align-self-center
      >
        <small>{{ 'general_close' | translate }}</small></ion-button
      >
    </div>
  </ion-footer>
}
